import { FunctionComponent } from 'react'

import type { UseModalProps } from '@chakra-ui/react'

import { MoreParametersProps } from '@wwt/pages/comparison'
import type { CreateSetModalProps } from '@wwt/widgets/modal/create-set'
import type { DeleteSetProps } from '@wwt/widgets/modal/delete-set'
import type { OfferConfigurationProps } from '@wwt/widgets/modal/offer-configuration'
import type { ReasonReviewProps } from '@wwt/widgets/modal/reason-review'
import type { RenameSetProps } from '@wwt/widgets/modal/rename-set'
import type { RequestPersonalDiscountProps } from '@wwt/widgets/modal/request-personal-discount'

import { LoginFormProps, RegistrationFormProps } from '@/features/auth'
import { BigFilterProps } from '@/widgets/BigFilter'
import type { ReservationsProps } from '@/widgets/ReservationsModal'

export enum ModalTypes {
	'OfferConfiguration' = 'OfferConfiguration',
	'ChatAssistant' = 'ChatAssistant',
	'BigFilter' = 'BigFilter',
	'RequestPersonalDiscount' = 'RequestPersonalDiscount',
	'Nps' = 'Nps',
	'Login' = 'Login',
	'TutorialVideo' = 'TutorialVideo',
	'TutorialReview' = 'TutorialReview',
	'TutorialMobile' = 'TutorialMobile',
	'ReasonReview' = 'ReasonReview',
	'ReasonInfo' = 'ReasonInfo',
	'CreateSet' = 'CreateSet',
	'RenameSet' = 'RenameSet',
	'DeleteSet' = 'DeleteSet',
	'Reservations' = 'Reservations',
	'Registration' = 'Registration',
	'MoreParameters' = 'MoreParameters'
}

export type ModalProps = {
	[ModalTypes.OfferConfiguration]: Omit<
		OfferConfigurationProps,
		'onDirty' | 'onClose'
	>
	[ModalTypes.ChatAssistant]: unknown
	[ModalTypes.BigFilter]: Omit<BigFilterProps, 'onDirty' | 'onClose'>
	[ModalTypes.RequestPersonalDiscount]: Omit<
		RequestPersonalDiscountProps,
		'onClose'
	>
	[ModalTypes.Nps]: unknown
	[ModalTypes.Login]: LoginFormProps
	[ModalTypes.TutorialVideo]: unknown
	[ModalTypes.TutorialReview]: unknown
	[ModalTypes.TutorialMobile]: unknown
	[ModalTypes.ReasonReview]: ReasonReviewProps
	[ModalTypes.ReasonInfo]: unknown
	[ModalTypes.CreateSet]: CreateSetModalProps
	[ModalTypes.RenameSet]: Omit<RenameSetProps, 'onDirty'>
	[ModalTypes.DeleteSet]: DeleteSetProps
	[ModalTypes.Reservations]: Omit<ReservationsProps, 'onClose'>
	[ModalTypes.Registration]: RegistrationFormProps
	[ModalTypes.MoreParameters]: Omit<MoreParametersProps, 'onDirty' | 'onClose'>
}

export enum ModalPriority {
	'low' = -1,
	'default' = 0,
	'high' = 1,
	'highest' = 2
}

export type ReactModalInfo =
	| {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			component: FunctionComponent<any>
	  }
	| {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			dialog: FunctionComponent<any>
	  }

export interface ModalInfo<T extends ModalTypes> {
	id: string
	type: T
	props?: ModalProps[T] | undefined
	priority: ModalPriority
	modalProps?: Partial<UseModalProps>
	childModals: ModalInfo<ModalTypes>[]
}
